import React from "react";
import { useTranslation } from "react-i18next";

const EventList = ({
  isDarkMode,
  isPlayer,
  selectedList,
  selectedItem,
  onItemClick,
  onItemDelete,
  isItemFromOverride,
  renderItemTitle,
  renderItemMeta,
}) => {
  const { t } = useTranslation();
  return (
    <div className="mb-4">
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-sm font-semibold">
          {t("calendar_ui.existing_activities", { count: selectedList.length })}
        </h3>
        <span className="text-xs opacity-70">{t("calendar_ui.click_hint")}</span>
      </div>

      <div className="space-y-2 max-h-32 overflow-auto pr-1">
        {selectedList.map((it) => {
          const isActive = selectedItem?.id === it?.id;
          const fromOv = isPlayer ? isItemFromOverride(it) : false;

          return (
            <button
              key={it.id}
              onClick={(e) => {
                if (e.altKey) onItemDelete(it);
                else onItemClick(it);
              }}
              className={`w-full text-left p-2 rounded-md border transition ${
                isActive
                  ? "border-blue-500 bg-blue-500/10"
                  : isDarkMode
                  ? "border-gray-700 bg-gray-900 hover:bg-gray-850"
                  : "border-gray-200 bg-white hover:bg-gray-50"
              }`}
            >
              <div className="flex items-center justify-between gap-2">
                <div className="text-sm font-medium">{renderItemTitle(it)}</div>
                {isPlayer && (
                  <div className="text-[11px] opacity-75">
                    {fromOv ? `⭐ ${t("calendar_ui.override")}` : t("pages.calendar.global")}
                  </div>
                )}
              </div>
              <div className="text-xs opacity-70 mt-0.5">
                {renderItemMeta(it) || `id: ${String(it.id).slice(0, 8)}…`}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default EventList;
